import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'point', 'Point', [["path",{"d":"M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0","key":"svg-0"}]]);